import { render, staticRenderFns } from "./PendingCampaignCard.vue?vue&type=template&id=1cd30e04&scoped=true"
import script from "./PendingCampaignCard.vue?vue&type=script&lang=ts"
export * from "./PendingCampaignCard.vue?vue&type=script&lang=ts"
import style0 from "./PendingCampaignCard.vue?vue&type=style&index=0&id=1cd30e04&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd30e04",
  null
  
)

export default component.exports